export default __webpack_public_path__ + "327b92cfbe43477e2c8a92225fe2d50a.png";